/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {Parallax} from "react-parallax";
import fondo from '../../../Recursos/fondo_reportes.png'
import fondo_cell from '../../../Recursos/fondo_reportes_cell.png'
import {useNavigate} from "react-router-dom";


const Reportes_Home = () => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate()

    return (

        <Parallax bgImage={sCell ? fondo_cell : fondo} bgImageAlt="equipo"
                  bgImageStyle={{width: "100%"}}
                  title={"equipo"}
                  lazy={true}
                  strength={200}
        >
            <Grid2
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={12}
                sx={{width: '100vw'}}
            >

                <Grid2 container size={12}
                       sx={{
                           maxWidth: '1400px',
                           px: 3,
                           py: !masSM ? 8 : 10,
                           color: '#fff'
                       }}>

                    <Grid2 container
                           justifyContent={'center'}
                           size={12}

                    >
                        <Typography sx={{fontSize: sCell ? 42 : 48, fontWeight: 800, textTransform: 'center'}}>
                            Documentación
                        </Typography>
                    </Grid2>

                    <Grid2 container
                           justifyContent={'center'}
                           size={12}>
                        <Typography sx={{fontSize: 20, textAlign: 'center', pt: 3, px: {xs: 2, md: 20}}}>
                            ofrecemos documentos detallados sobre nuestra labor y finanzas, garantizando transparencia y
                            responsabilidad en la gestión de recursos.
                        </Typography>
                    </Grid2>

                    <Grid2 container
                           justifyContent={'center'}
                           size={12}
                           sx={{pt: 4}}>
                        <Button
                            onClick={() => navigate('/Documentacion')}
                            sx={{backgroundColor: '#000', color: 'white', borderRadius: 10}}>
                            <Typography sx={{fontSize: 20, py: 1, px: 4}}>
                                Ver Documentación
                            </Typography>
                        </Button>
                    </Grid2>

                </Grid2>
            </Grid2>

        </Parallax>


    )

}
export default Reportes_Home